import React from "react";
import { Img } from "../../../Img";
export const SocialMedia = ({ socialMedia }) => (React.createElement("div", { className: "social-media" }, socialMedia &&
    socialMedia.map((item, i) => (React.createElement("a", { className: "social-media__item", key: i, href: item.iconLink, target: "_blank", rel: "noreferrer" },
        React.createElement(Img, { className: "social-media__icon", src: item.iconUrl, alt: item.iconAlt }))))));
